@for (box of boxes(); track box.code) {
    <app-tax-return-summary-details-row
        label="payroll.taxForms.{{ returnType() }}.employee.boxDescriptionFormat"
        [labelParams]="{ code: box.boxNumber, description: box.description }"
        [amount]="boxAmounts()[$index]"
        [isCurrency]="box.isCurrency"
    >
        <!-- Currently only used by Box 45 currently, but could allow us to provide other translated plain-text fields in the future-->
        @if (isTranslatable(boxAmounts()[$index])) {
            <div class="text" [translate]="boxAmounts()[$index][0]" [translateParams]="boxAmounts()[$index][1]"></div>
        }
        @if (taxForm().errors[box.xmlNameCamel]) {
            <ui-badge type="danger">{{ 'payroll.taxReturns.t4SummaryStatuses.error' | translate }}</ui-badge>
        }
    </app-tax-return-summary-details-row>
}
